export default function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
}



//////////////////
// WEBPACK FOOTER
// /home/daniel/www/navigator.palladium.cz/node_modules/d3-interpolate/src/round.js
// module id = ../../../node_modules/d3-interpolate/src/round.js
// module chunks = 0